var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"btn",staticClass:"btn",class:_vm.mode === 'outline' ? 'outline' : '',style:({
    backgroundColor: _vm.disabled
      ? '#EFEFEF'
      : _vm.mode === 'outline'
      ? 'transparent'
      : _vm.backgroundColor,
    color: _vm.mode === 'outline' ? _vm.backgroundColor : '#fff',
    borderColor: _vm.mode === 'ouline' ? 'transparent' : _vm.backgroundColor
  }),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"mouseenter":function($event){return _vm.handleButtonHover(true)},"mouseleave":function($event){return _vm.handleButtonHover(false)},"click":_vm.handleButtonClick}},[_vm._t("default"),(_vm.label)?_c('span',{ref:"contentLabel",style:({
      color: _vm.disabled ? '#CCCCCC' : _vm.spanCustomStyles
    }),domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }